import {isEmpty} from 'lodash';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    templateUrl: 'investment-title.html',
    selector: 'app-manual-invest-investment-title',
    styleUrls: ['./investment-title.css']
})
export class InvestmentTitleComponent implements OnInit {

    private static readonly DefaultPortfolioName = 'NEW PORTFOLIO';

    public title: string;
    public editMode: boolean;
    @Input()
    color: string;

    @Input()
    editColor: string;

    @Input()
    editTextColor: string;

    @Output()
    public readonly titleChangedEvent = new EventEmitter<string>();

    ngOnInit(): void {
        this.saveTitle(InvestmentTitleComponent.DefaultPortfolioName);
    }

    onEditModeTurnedOn(): void {
        this.editMode = true;
    }

    saveTitle(title: string): void {
        if (!isEmpty(title) && title.length <= 35) {
            this.title = title.trim().substring(0, 35);
            this.titleChangedEvent.emit(this.title);
            this.editMode = false;
        }
    }
}
